import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import webservice from '../common/Webservice';
import {Link} from 'react-router-dom';
import {TABS_STRUCTURE, dispatchUpdateData, MEDIA_SIZES} from "../misc/Shared";
import Media from "react-media";
import {joinClassNames, SelectInput} from "@utahdts/dts-react-common";
import {isEmpty} from "lodash";

const propTypes = {
	admin: PropTypes.bool.isRequired,
	currentCobiId: PropTypes.number.isRequired,
	currentYear: PropTypes.number.isRequired,
	currentTab: PropTypes.string,
	draft: PropTypes.bool,
	editing: PropTypes.object,
	// The browser history object (provided by react router)
	history: PropTypes.object.isRequired,
};

const defaultProps = {
	currentTab: undefined,
};

const mapStateToProps = (state) => {
    return {
		admin: state.app.admin,
		currentCobiId: state.app.currentCobiId,
        currentYear: state.app.currentYear,
        currentTab: state.app.currentTab,
		draft: state.app.draft,
		editing: state.app.editing,
    };
};

class Tabs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentTabs: undefined,
			tabDatalist: [],
			tabsReady: false
        };

        this.tabs = {
            [TABS_STRUCTURE.OVERVIEW]: {
                tab: 'overviewTab',
                url: TABS_STRUCTURE.OVERVIEW,
                title: 'Overview'
            },
            [TABS_STRUCTURE.ISSUES]: {
                tab: 'issueTab',
                url: TABS_STRUCTURE.ISSUES,
                title: 'Issues'
            },
            [TABS_STRUCTURE.PERFORMANCE]: {
                tab: 'performanceTab',
                url: TABS_STRUCTURE.PERFORMANCE,
                title: 'Performance'
            },
            [TABS_STRUCTURE.BACKGROUND]: {
                tab: 'backgroundTab',
                url: TABS_STRUCTURE.BACKGROUND,
                title: 'Background'
            },
            [TABS_STRUCTURE.FINANCIALS]: {
                tab: 'financialTab',
                url: TABS_STRUCTURE.FINANCIALS,
                title: 'Financials'
            }
        };

        this.tabsOrder = [
            TABS_STRUCTURE.OVERVIEW,
            TABS_STRUCTURE.ISSUES,
            TABS_STRUCTURE.PERFORMANCE,
            TABS_STRUCTURE.BACKGROUND,
            TABS_STRUCTURE.FINANCIALS
        ];

		this.getInitialData();
    }

    componentDidUpdate(prevProps) {
        if (((this.props.currentCobiId !== prevProps.currentCobiId) || (this.props.currentYear !== prevProps.currentYear)) && this.state.tabsReady) {
            webservice.public.tab.tabsById(this.props.currentCobiId, this.props.currentYear).then(data => {
				let tabDatalist = this.tabsOrder.reduce((result, tab) => {
					if (data[this.tabs[tab].tab]) {
						result.push({
							value: this.tabs[tab].url,
							label: this.tabs[tab].title
						});
					}
					dispatchUpdateData({path: `app.editing.${tab}`, field: 'active', value: data[this.tabs[tab].tab]});
					return result;
				}, []);
				dispatchUpdateData({path: 'app.editing', field: 'cobiIdActive', value: data.cobiIdActive});
				this.setState({currentTabs: data, tabDatalist: tabDatalist});
            	if(!data[this.tabs[this.props.currentTab].tab]) {
					dispatchUpdateData({path: 'app', field: 'currentTab', value: 'overview'});
				}
            });
        }
    }

	getInitialData() {
		webservice.public.tab.tabsById(this.props.currentCobiId, this.props.currentYear).then(data => {
			if (isEmpty(data)) {
				this.props.history.push(`/${this.props.currentYear}/1/overview${this.props.draft ? '/draft' : ''}`);
			}
			if (this.props.currentCobiId === data.cobiId) {
				let tabDatalist = this.tabsOrder.reduce((result, tab) => {
					if (data[this.tabs[tab].tab]) {
						result.push({
							value: this.tabs[tab].url,
							label: this.tabs[tab].title
						});
					}
					dispatchUpdateData({path: `app.editing.${tab}`, field: 'active', value: data[this.tabs[tab].tab]});
					return result;
				}, []);
				dispatchUpdateData({path: `app.editing`, field: 'cobiIdActive', value: data.cobiIdActive});
				this.setState({currentTabs: data, tabDatalist: tabDatalist, tabsReady: true});
				if (!data[this.tabs[this.props.currentTab].tab] && !this.props.admin) {
					this.props.history.push(`/${this.props.currentYear}/${this.props.currentCobiId}/overview${this.props.draft ? '/draft' : ''}`);
				}
			} else {
				this.getInitialData();
			}
		});
	}

    render() {
        return (
			<Media query={MEDIA_SIZES.TABLET_NARROW_MIN_WIDTH}>
				{matches =>
					matches ? (
						this.props.admin ?
							<ul className="flex no-print" id="tabs">
								{this.state.currentTabs && this.tabsOrder.map(tab => {
									return (<li key={"tab-" + this.tabs[tab].tab}
												className={joinClassNames(
													this.props.currentTab === this.tabs[tab].url ? 'active' : '',
													this.props.editing[tab].active ? '' : 'disabled',
													this.props.editing[tab].edited ? 'edited' : ''
												)}
												id={'tab-' + tab}>
										<Link to={`/admin/editor/${this.props.currentYear}/${this.props.currentCobiId}/${this.tabs[tab].url}`}>
											{this.tabs[tab].title}
										</Link>
									</li>);
								})}
							</ul>
							: <ul className="flex no-print" id="tabs">
								{this.state.currentTabs && this.tabsOrder.map(tab => {
									return this.state.currentTabs[this.tabs[tab].tab] ?
										<li key={"tab-" + this.tabs[tab].tab} className={this.props.currentTab === this.tabs[tab].url ? 'active' : ''} id={'tab-' + tab}>
											<Link to={`/${this.props.currentYear}/${this.props.currentCobiId}/${this.tabs[tab].url}${this.props.draft ? '/draft' : ''}`}>
												{this.tabs[tab].title}
											</Link>
										</li> : undefined;
								})}
							</ul>
					) : (
						<SelectInput
							field="tab"
							label=""
							showLabel={false}
							allowClear={false}
							showSearch={false}
							className="mobile normal-font tab-select no-print"
							options={this.state.tabDatalist}
							value={this.props.currentTab}
							onChange={(field, val) => this.props.history.push(`/${this.props.currentYear}/${this.props.currentCobiId}/${val}${this.props.draft ? '/draft' : ''}`)}
						/>
					)
				}
			</Media>
        );
    }
}

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;

export default connect(mapStateToProps)(Tabs);
